import { FETCH_VATS_OPTIONS_START, FETCH_VATS_OPTIONS_SUCCESS, FETCH_VATS_OPTIONS_FAILED } from "../actions";

const vatsReducer = (state = {}, action) => {
  switch (action.type) {
    case FETCH_VATS_OPTIONS_START:
      return { ...state, inProgress: true };
    case FETCH_VATS_OPTIONS_SUCCESS:
      return {
        ...state,
        list: action.payload.vats,
        inProgress: false
      };
    case FETCH_VATS_OPTIONS_FAILED:
    default:
      return state;
  }
};

export default vatsReducer;
